export default "__VITE_ASSET__ded27f2e__"